// Used to change layouts when tables no longer fit in their column

import { uiDebounce } from '../util/debounce';

const Responsive = {
	data() {
		return {
			minWidth: null,
			condensed: false,
			debouncedHandleResize: uiDebounce(() => this.handleResize())
		};
	},
	created() {
		window.addEventListener('resize', this.debouncedHandleResize);
	},
	mounted() {
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.debouncedHandleResize);
	},
	methods: {
		handleResize() {
			const columnStyle = window.getComputedStyle(this.$el);
			const columnPadding = parseInt(columnStyle.getPropertyValue('padding-left'), 10) + parseInt(columnStyle.getPropertyValue('padding-right'), 10);
			const columnWidth = this.$el.clientWidth - columnPadding;
			const tableWidth = this.$el.querySelector('table') ? this.$el.querySelector('table').clientWidth : 0;

			if (tableWidth > columnWidth) {
				this.minWidth = tableWidth;
				this.condensed = true;
			}

			if (columnWidth >= this.minWidth) {
				this.condensed = false;
			}
		}
	}
};

export default Responsive;
